// extracted by mini-css-extract-plugin
export default {"frameContent":"uMPcfzU4GfPEKhfzrrSF","frame":"GQNZUaFKI0I1OXwf_10P","loader":"Y27FRAiUBrILyAQCZcQZ","placeHolderShimmer":"C4maCzZkOAxna_ONFLZA"};